import { useState, useEffect, useMemo, useRef } from "react";
import Index from "../../../component/Index";
import { doGet } from "../../../service/UserIndex";
import moment from "moment";
import Constants from "../../../component/common/constants";
import { manageNotificationCount } from "../../../redux/user/action";

const Notification = () => {
  const dispatch = Index.useDispatch();
  const token = Index.useSelector((state) => state.UserReducer.token);
  const { displaySettings, rowsPerPage, twoSideArrowZoom, sorting, theme } =
    Index.useSelector((state) => state.UserReducer);

  const location = Index.useLocation();

  const dataGridRef = useRef(null);
  const [notification, setNotification] = useState([]);
  const [loader, setLoader] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);
  const [page, setPage] = useState(1); // Current page
  const [pageSize, setPageSize] = useState(16);
  const [tradeType, setTradeType] = useState("");
  const [dataTableHeight, setDataTableHeight] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: rowsPerPage,
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const indexOfLastItem = page * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentNotifications = notification?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  //Columns for table
  const columns = [
    {
      field: "id",
      headerName: "Sr.",
      width: 100,
      hideable: false,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "stock_name",
      headerName: "Script",
      width: 250,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "tradeType",
      headerName: "Trade Type",
      width: 180,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "timeFrame",
      headerName: "Time Frame",
      width: 180,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "interval",
      headerName: "Interval",
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "stock_price",
      headerName: "Price",
      width: 200,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "tag",
      headerName: "Tag",
      width: 100,
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Index.Button
          className={
            params.value.toLowerCase() === "buy"
              ? "green-buy-btn"
              : params.value.toLowerCase() === "sell" ||
                params.value.toLowerCase() === "exit"
              ? "red-buy-btn"
              : params.value.toLowerCase() === "watch"
              ? "blue-watch-btn"
              : ""
          }
          disableRipple
        >
          {params.value}
        </Index.Button>
      ),
    },
    {
      field: "createdAt",
      headerName: "Date and Time",
      width: 270,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
  ];

  const row = useMemo(() => {
    return notification?.map((item, index) => {
      return {
        id: index + 1,
        tag: item?.tag || "",
        status: item?.status,
        stock_name: item?.stock_name,
        stock_price: item?.stock_price,
        token: item?.token,
        tradeType: item?.tradeType,
        timeFrame: Constants.shortPositionalTimeframe[item?.timeFrame] ?? "-",
        interval: Constants.shortInterval[item?.interval],
        createdAt: moment(item?.createdAt).format("DD/MM/YYYY hh:mm:ss A"),
      };
    });
  }, [notification]);

  const handleSeenNotification = async () => {
    try {
      const params = {
        page,
        dataPerPage: rowsPerPage,
      };
      const response = await Index.DataService(token).get(
        Index.Api.user.seenNotification,
        { params }
      );
      dispatch(manageNotificationCount(response?.data?.data?.totalCount));
    } catch (error) {}
  };

  const fetchData = async () => {
    try {
      const { reset, order, tags } =
        sorting[Constants.sortingPath[location?.pathname]];
      const params = {
        page,
        dataPerPage: rowsPerPage,
        sortDate: reset ? -1 : "",
        sort: order ? order : "",
        tags: tags,
        tradeType,
      };
      const response = await Index.DataService(token).get(
        Index.Api.user.getNotifications,
        { params }
      );
      setNotification(response?.data?.data?.notifications ?? []);
      setNotificationCount(response?.data?.data?.totalCount);
      setTimeout(() => {
        setLoader(false);
      }, 1000);
      handleSeenNotification();
    } catch (error) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sorting[Constants.sortingPath[location?.pathname]], page, rowsPerPage, tradeType]);

  useEffect(() => {
    setPaginationModel({
      page: 0,
      pageSize: rowsPerPage,
    });
  }, [rowsPerPage]);

  //Data table height
  let mainContentElement = document.querySelector(".main-content-sec");
  let topSecElement = document.querySelector(".list-heading-main");

  useEffect(() => {
    if (mainContentElement && topSecElement) {
      const mainHeight = mainContentElement.clientHeight;
      const topSecHeight = topSecElement.clientHeight;
      setDataTableHeight(mainHeight - topSecHeight - 25);
    }
  }, [mainContentElement, topSecElement, twoSideArrowZoom]);

  return (
    <>
      <Index.Box className="dashboard-main">
        <Index.Box className="dashboard-wrapper">
          <Index.Box
            className={`main-content-sec ${
              displaySettings?.UtilityBar == "left"
                ? "main-content-sec-right"
                : ""
            } ${twoSideArrowZoom && "hide-main-content-margin"}`}
          >
            <Index.Box className="list-heading-main">
              <Index.Typography className="list-heading-text">
                Notifications
              </Index.Typography>
              <Index.Box className="cus-input-grp exit-stock-modal-box index-select notification-select">
                <Index.Box className="form-group">
                  <Index.FormControl className="form-control-user drop-form-control">
                    <Index.Select
                      fullWidth
                      name="category"
                      className={`form-control ${
                        !tradeType || theme === "Light"
                          ? "select-form-control"
                          : ""
                      }`}
                      displayEmpty
                      value={tradeType}
                      placeholder="Select Market"
                      onChange={(e) => {
                        const value = e?.target?.value;
                        setTradeType(value);
                      }}
                    >
                      <Index.MenuItem
                        value=""
                        className="drop-menuitem game-item"
                      >
                        All
                      </Index.MenuItem>
                      <Index.MenuItem
                        value="Intraday"
                        className="drop-menuitem game-item"
                      >
                        Intraday
                      </Index.MenuItem>
                      <Index.MenuItem
                        value="Positional"
                        className="drop-menuitem game-item"
                      >
                        Positional
                      </Index.MenuItem>
                    </Index.Select>
                  </Index.FormControl>
                </Index.Box>
              </Index.Box>
            </Index.Box>
            <Index.Box
              className="table-sec"
              // className={`table-sec ${
              //   row.length < 10 ? "transaction-table" : ""
              // }`}
            >
              <Index.Box
                className="notification-table-main"
                sx={{ width: "100%", height: dataTableHeight }}
              >
                {/* {row && row?.length > 0 ? ( */}
                <Index.DataGrid
                  ref={dataGridRef}
                  rows={loader ? [] : row}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel,
                    },
                  }}
                  rowCount={notificationCount}
                  pageSizeOptions={[1000]}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  disableRowSelectionOnClick
                  components={{
                    NoRowsOverlay: () => (
                      <Index.NoRowsOverlay loader={loader} />
                    ),
                  }}
                  localeText={{
                    MuiTablePagination: {
                      labelDisplayedRows: ({ from, to, count, estimated }) => {
                        if (!estimated) {
                          return `${from} – ${to} of ${
                            count !== -1 ? count : `${to}`
                          }`;
                        }
                        return `${from} – ${to} of ${
                          count !== -1
                            ? count
                            : `${estimated > to ? estimated : to}`
                        }`;
                      },
                    },
                  }}
                />
                {/* ) : (
                  <Index.Box
                    sx={{ textAlign: "center", padding: "20px" }}
                    className="text-data"
                  >
                    No notification found
                  </Index.Box>
                )} */}
              </Index.Box>
            </Index.Box>
            {/* <Index.Box className="noti-page-box">
              {currentNotifications?.map((notification, index) => {
                return (
                  <>
                    <Index.Box className="single-message-box" key={index}>
                      <Index.Typography
                        className={
                          notification?.message?.charAt(0).toLowerCase() == "s"
                            ? "stopLoss"
                            : "targetAchived"
                        }
                      >
                        {notification.message}
                        <small> {new Date(notification.createdAt)?.toLocaleString()}</small>
                      </Index.Typography>
                    </Index.Box>
                  </>
                );
              })}
            </Index.Box>

            <Index.Box className="notification-sec">
              <Index.Box className="pagination-sec">
                <Index.Box className="flex">
                  <>
                    <Index.Pagination
                      count={Math.ceil(notification?.length / pageSize)}
                      page={page}
                      onChange={handleChangePage}
                      shape="rounded"
                      hidePrevButton
                      hideNextButton
                    />
                  </>
                </Index.Box>
              </Index.Box>
            </Index.Box> */}
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
};

export default Notification;
